// Shared delivery zones & rates — mirror of DELIVERY_ZONES in backend/server.py.
export const UK_COUNTRY_NAMES = [
  "united kingdom", "uk", "england", "scotland", "wales", "northern ireland", "great britain",
];

export const EUROPE_COUNTRIES = [
  "Ireland", "France", "Germany", "Spain", "Italy", "Netherlands", "Belgium",
  "Portugal", "Poland", "Romania", "Greece", "Sweden", "Denmark", "Finland",
  "Norway", "Switzerland", "Austria", "Czechia", "Hungary", "Croatia",
  "Slovakia", "Slovenia", "Bulgaria", "Estonia", "Latvia", "Lithuania",
  "Luxembourg", "Malta", "Cyprus", "Iceland", "Turkey",
];

export const WORLD_COUNTRIES = [
  "United States", "Canada", "Australia", "New Zealand", "United Arab Emirates",
  "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman", "Israel", "South Africa",
  "Nigeria", "Ghana", "Kenya", "Uganda", "Tanzania", "Zimbabwe", "Zambia",
  "Ethiopia", "Jamaica", "Trinidad and Tobago", "Barbados", "India", "Pakistan",
  "Bangladesh", "Sri Lanka", "Philippines", "Malaysia", "Singapore", "Hong Kong",
  "Japan", "South Korea", "China", "Thailand", "Vietnam", "Brazil", "Mexico",
  "Argentina", "Chile", "Colombia", "Ukraine", "Other country",
];

export function deliveryZone(country) {
  const c = (country || "").trim().toLowerCase();
  if (!c || UK_COUNTRY_NAMES.includes(c)) return "uk";
  if (EUROPE_COUNTRIES.some((n) => n.toLowerCase() === c)) return "europe";
  return "world";
}

export const DELIVERY_RATES = {
  uk: { rate: 4.99, free: 50, label: "Delivery (3–5 days)" },
  europe: { rate: 6.99, free: 80, label: "Delivery to Europe (5–8 days)" },
  world: { rate: 8.99, free: 100, label: "International delivery (7–12 days)" },
};

export function deliveryFor(subtotal, country = "United Kingdom") {
  const zone = DELIVERY_RATES[deliveryZone(country)];
  return subtotal >= zone.free ? 0 : zone.rate;
}

export const COUNTRY_GROUPS = [
  { label: "United Kingdom", options: ["United Kingdom"] },
  { label: "Europe", options: EUROPE_COUNTRIES },
  { label: "Rest of the world", options: WORLD_COUNTRIES },
];
